import { NumericAlertKinds } from "../NumericAlertKinds";
import { IItem } from "./IItem";

export interface INumericRangeValidatable extends IItem {
  name: string;
  numericAlertKind: NumericAlertKinds;
  upperLimit: number;
  lowerLimit: number;
  upperLimitAlertColor: string;
  lowerLimitAlertColor: string;
  isNumericValueInRange(): boolean;
  getNumericRangeAlertColor(): string;
}

export function instanceOfINumericRangeValidatable(instance: any): instance is INumericRangeValidatable {
  if (!instance) { return false; }
  return (instance.numericAlertKind !== undefined);
}
